import { EXTENDED_RELATIONSHIP_LABELS, ExtendedRelationship } from '@customTypes/constants';

interface FormatNameParams {
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  credentials?: string | null | undefined;
  allowFirstNameOnly?: boolean;
  includeCredentials?: boolean;
}

export const formatName = (params: FormatNameParams): string | null => {
  const { allowFirstNameOnly = false, includeCredentials = false } = params;

  const firstName = params.firstName || '';
  const lastName = params.lastName || '';
  const credentials = params.credentials || '';

  if (!firstName.length) {
    return null;
  }

  if (!lastName.length) {
    if (allowFirstNameOnly) {
      return firstName;
    }

    return null;
  }

  const fullName = `${firstName} ${lastName}`;

  if (includeCredentials && credentials.length) {
    return `${fullName}, ${credentials}`;
  }

  return fullName;
};

export const getRelationshipLabel = (relationship: ExtendedRelationship, defaultLabel?: string): string => {
  const relationshipLabel = EXTENDED_RELATIONSHIP_LABELS[relationship];

  if (relationshipLabel) {
    return relationshipLabel;
  }

  return defaultLabel ?? relationship;
};
